module.exports = __webpack_public_path__ + "static/media/flag-uz.f0eb4284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-uz.svg
// module id = 847
// module chunks = 7